var t = [],
    i = -1,
    s = !1,
    n = null,
    h = function () {
  function h(t) {
    if (void 0 === t && (t = {}), t.callback) {
      if (-1 !== this.max) {
        this.bindMethods();
        var i = {
          el: null,
          loop: !1,
          random: !1,
          vertical: !1,
          callback: this.done,
          auto: !1,
          interval: 5,
          init: !0,
          swipe: !0,
          mouseSwipe: !1,
          startAt: 0,
          threshold: 60
        };
        this.options = Object.assign(i, t), this.el = t.el, this.changing = !1, this.max = t.length > 0 ? t.length : t.el && t.el.children ? t.el.children.length : -1, this.index = isNaN(t.startAt) || t.startAt === i.startAt ? 0 : Math.max(0, Math.min(t.startAt, this.max)), this.intervalID = null, this.touch = {
          startX: 0,
          startY: 0,
          endX: 0,
          endY: 0
        }, this.diagonalMax = 125, this.options.init && this.init();
      } else console.warn("Slidemanager: Missing `el` or `length` property in constructor.");
    } else console.warn("Slidemanager: Missing `callback` property in constructor.");
  }

  var o = h.prototype;
  return o.bindMethods = function () {
    this.intervalFn = this.intervalFn.bind(this), this.startAuto = this.startAuto.bind(this), this.stopAuto = this.stopAuto.bind(this), this.touchStart = this.touchStart.bind(this), this.touchEnd = this.touchEnd.bind(this), this.done = this.done.bind(this);
  }, o.init = function () {
    return 0 === this.max ? null : (this.options.auto && this.startAuto(), this.options.swipe && this.events(), this);
  }, o.destroy = function () {
    return 0 === this.max ? null : (this.changing = !1, this.options.swipe && this.el && (this.options.mouseSwipe && (this.el.removeEventListener("mousedown", this.touchStart), this.el.removeEventListener("mouseup", this.touchEnd)), this.el.removeEventListener("touchstart", this.touchStart), this.el.removeEventListener("touchend", this.touchEnd)), this.options.auto && this.stopAuto(), this);
  }, o.getIndex = function () {
    return this.index;
  }, o.prev = function () {
    this.goTo(this.index - 1);
  }, o.next = function () {
    this.goTo(this.index + 1);
  }, o.goTo = function (t, i) {
    if (t !== this.index && !this.isChanging()) {
      var s = this.checkLoop(t),
          n = this.createEvent(s, i);
      s !== this.index ? (this.index = s, this.options.callback(n)) : this.changing = !1;
    }
  }, o.done = function () {
    this.changing = !1, this.options.auto && this.startAuto();
  }, o.events = function () {
    this.el && (this.options.mouseSwipe && (this.el.addEventListener("mousedown", this.touchStart), this.el.addEventListener("mouseup", this.touchEnd)), this.el.addEventListener("touchstart", this.touchStart), this.el.addEventListener("touchend", this.touchEnd));
  }, o.touchStart = function (t) {
    this.touch.startX = "touchstart" === t.type ? t.touches[0].screenX : t.screenX, this.touch.startY = "touchstart" === t.type ? t.touches[0].screenY : t.screenY;
  }, o.touchEnd = function (t) {
    this.touch.endX = "touchend" === t.type ? t.changedTouches[0].screenX : t.screenX, this.touch.endY = "touchend" === t.type ? t.changedTouches[0].screenY : t.screenY, this.handleSwipe();
  }, o.isGoingToX = function () {
    return this.touch.endX < this.touch.startX && this.touch.startX - this.touch.endX <= this.diagonalMax || this.touch.endX > this.touch.startX && this.touch.endX - this.touch.startX <= this.diagonalMax;
  }, o.isGoingToY = function () {
    return this.touch.endY < this.touch.startY && this.touch.startY - this.touch.endY <= this.diagonalMax || this.touch.endY > this.touch.startY && this.touch.endY - this.touch.startY <= this.diagonalMax;
  }, o.handleSwipe = function () {
    this.changing || (this.options.vertical ? (this.touch.endY < this.touch.startY && this.touch.startY - this.touch.endY >= this.options.threshold && this.isGoingToX() && this.callback(-1), this.touch.endY > this.touch.startY && this.touch.endY - this.touch.startY >= this.options.threshold && this.isGoingToX() && this.callback(1)) : (this.touch.endX < this.touch.startX && this.touch.startX - this.touch.endX >= this.options.threshold && this.isGoingToY() && this.callback(-1), this.touch.endX > this.touch.startX && this.touch.endX - this.touch.startX >= this.options.threshold && this.isGoingToY() && this.callback(1)));
  }, o.startAuto = function () {
    this.intervalID && this.stopAuto(), this.intervalID = (i++, t.push({
      id: i,
      fn: this.intervalFn,
      interval: 1e3 * this.options.interval,
      lastTime: performance.now()
    }), s || (s = !0, function i() {
      n = requestAnimationFrame(i), t.forEach(function (t) {
        (t.interval < 17 || performance.now() - t.lastTime >= t.interval) && (t.fn(), t.lastTime = performance.now());
      });
    }()), i);
  }, o.intervalFn = function () {
    this.changing || this.callback(-1);
  }, o.stopAuto = function () {
    !function (i) {
      for (var h = 0; h < t.length; h++) {
        if (i === t[h].id) {
          t.splice(h, 1);
          break;
        }
      }

      0 === t.length && (cancelAnimationFrame(n), s = !1);
    }(this.intervalID), this.intervalID = null;
  }, o.isChanging = function () {
    return !!this.changing || (this.changing = !0, !1);
  }, o.newIndex = function (t) {
    return this.checkLoop(t > 0 ? this.index - 1 : this.index + 1);
  }, o.newRandomIndex = function () {
    var t;

    do {
      t = Math.floor(Math.random() * this.max);
    } while (t === this.index);

    return t;
  }, o.checkLoop = function (t) {
    return t < 0 ? this.options.loop ? this.max - 1 : 0 : t > this.max - 1 ? this.options.loop ? 0 : this.max - 1 : t;
  }, o.createEvent = function (t, i) {
    var s = t > this.index ? 1 : -1;
    return this.max > 2 && (0 === this.index && t === this.max - 1 ? s = -1 : this.index === this.max - 1 && 0 === t && (s = 1)), {
      current: t,
      previous: this.index,
      direction: s,
      data: i,
      done: this.done
    };
  }, o.callback = function (t) {
    if (!this.isChanging()) {
      var i = this.options.random ? this.newRandomIndex() : this.newIndex(t),
          s = this.createEvent(i);
      i !== this.index ? (this.options.auto && this.stopAuto(), this.index = i, this.options.callback(s)) : this.changing = !1;
    }
  }, h;
}();

export default h;